import React, { useEffect, useRef, useState } from "react";
import UserOperationContentModal from "./UserOperationContentModal";
import Static_modal from "../etc/Static_modal";
import * as Cesium from "cesium";
import Modal from "react-bootstrap/Modal";
import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import AuthService_Operation from "../../../services/Operation.serviceV3";
import { useNavigate } from "react-router-dom";
import L, { point } from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  useMapEvent,
  LayersControl,
  AttributionControl,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import toGeoJSON from "@mapbox/togeojson";
import { Button, Tooltip, Overlay, Spinner, Table } from "react-bootstrap";
import PaginationS from "../../admin/Pagination";
import { connect } from "formik";
import * as turf from "@turf/turf";
import { Grid } from "@mui/material";
import { useLanguage } from "../../../Language/LanguageContext";
////React-Icon
import { RiFileExcel2Line } from "react-icons/ri";
import { TbDrone } from "react-icons/tb";
import { MdSettingsRemote } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { LuCopyPlus, LuCopyCheck, LuCopyMinus } from "react-icons/lu";

//Steps
import User_Drone_Status from "../../../Style_Component/Steps/User_Drone_Status";
import Plan_Status from "../../../Style_Component/Steps/Plan_Status";

//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";

//Icons
import { MdDateRange } from "react-icons/md";
import { FaUserAstronaut } from "react-icons/fa";
import { GiDeliveryDrone } from "react-icons/gi";
import docgif from "../../../picture/investigation.gif";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

const OperationTable = () => {
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const [activeTab, setActiveTab] = useState("myOperations");
  const [showUserOperationModal, setShowUserOperationModal] = useState(false);
  const handleToggleUserOperationModal = () => {
    setShowUserOperationModal(!showUserOperationModal);
  };

  const mapRef = useRef(null);
  let Navigate = useNavigate();
  // const [viewer, setViewer] = useState(null);
  // const [reVision, setRevision] = useState(true);
  ///Modal
  const [modalToggle, setModalToggle] = useState({
    showdata_check: false,
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });

  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const modal_handleClose = () => {
    // Close all modals
    setModalToggle({
      showdata_check: false,
      modalSuccess: false,
      modalDenied: false,
      modalErr: false,
      modalwait: false,
    });
  };

  const [loading, setLoading] = useState(true);
  const [showtooltip, setShowtooltip] = useState(false);
  const targettool = useRef(null);
  const [itemsA, setItemsA] = useState([]);
  const [itemsB, setItemsB] = useState([]);
  const [cancancle, setCancancle] = useState(false);
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [selectedInformation, setSelectedInformation] = useState([]);
  const [showInfomationA, setShowInfomationA] = useState(false);
  const [showInfomationB, setShowInfomationB] = useState(false);
  const [showApproveDroneList, setShowAprroveDroneList] = useState(false);
  const [currentDronePage, setCurrentDronePage] = useState(0);
  const startDronePageIndex = currentDronePage * 4;
  const endDronePageIndex = startDronePageIndex + 4;
  const [droneArray, setdroneArray] = useState([]);
  const currentDroneItems = droneArray.slice(
    startDronePageIndex,
    endDronePageIndex
  );
  const [showTooltip, setShowTooltip] = useState(false);
  const [target, setTarget] = useState(null);
  const [valuetool, setValuetool] = useState();
  const [clipboard_icon, setclipboard_Icon] = useState(
    <LuCopyPlus style={{ width: "25px", height: "25px" }} />
  );

  const ClipBoard = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };
  const ClipBHover = () => {
    setclipboard_Icon(
      <LuCopyMinus style={{ width: "25px", height: "25px" }} />
    );
  };

  const ClipBClick = (text) => {
    setclipboard_Icon(
      <LuCopyCheck style={{ width: "25px", height: "25px", color: "green" }} />
    );
    ClipBoard(text);
  };
  const handleClick = (event) => {
    setShowTooltip(!showTooltip);
    setTarget(event.target);
    setValuetool(event.target.value);
    setclipboard_Icon(<LuCopyPlus style={{ width: "25px", height: "25px" }} />);
  };
  const handleClose = () => {
    setShowInfomationA(false);
    setShowInfomationB(false);
    setShowAprroveDroneList(false);
    setCancancle(false);
  };
  const handleShow = () => {
    setShowInfomationA(true);
  };

  const droneCoopDataApprove = (dronelist, operation_id) => {
    let operationlist = AuthService.dronedataco(dronelist, operation_id);
    operationlist.then((response) => {
      setdroneArray(response.data);
      setShowAprroveDroneList(true);
    });
  };
  function autocomplete(end, id) {
    const currentDate = new Date().getTime();
    const Dateend = new Date(end).getTime();
    if (Dateend < currentDate) {
      CompleteOperation(id);
    }
  }
  function compareDate(start, end) {
    const currentDate = new Date();
    console.log(currentDate.getTime());
    const Datestart = new Date(start);
    console.log(Datestart.getTime());
    if (Datestart > currentDate) {
      setCancancle(true);
    }
  }
  function formatDate(input) {
    //console.log(input)
    // Parse the date string to create a new Date object
    const date = new Date(input);

    // Extract day, month, year, hours, and minutes
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Return the formatted date
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
  const DeAuthorizedOperation = (operationid) => {
    let deoperation = AuthServiceV2.DeAuthorizedOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const AcceptRecindedOperation = (operationid) => {
    let deoperation = AuthServiceV2.AcceptRecindedOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const CompleteOperation = (operationid) => {
    let deoperation = AuthServiceV2.CompleteOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const CancelOperation = (operationid) => {
    let deoperation = AuthServiceV2.CancelOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const [reload_data, setReload_Data] = useState(true);
  const getOperation = () => {
    let operationlist = AuthServiceV2.Opearationdata();
    if (operationlist != null) {
      operationlist
        .then((response) => {
          console.log(response.data);
          const tempArray = [];
          const tempArray2 = [];
          const indata = response.data.operator_data;
          const tempAreaObj = {};
          const tempAreaObj2 = {};
          for (
            let operationCount = 0;
            operationCount < response.data.operator_data.length;
            operationCount++
          ) {
            tempArray.push(indata[operationCount]);
          }
          for (
            let operationCount = 0;
            operationCount < response.data.agency_data.length;
            operationCount++
          ) {
            tempArray2.push(response.data.agency_data[operationCount]);
          }
          tempArray.map((data) => {
            if (data.operation_status_name === "อนุมัติ") {
              console.log(data.operation_id);
              autocomplete(data.end_time, data.operation_id);
            }
          });
          setItemsA(tempArray.reverse());
          setItemsB(tempArray2.reverse());
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const checkoperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");

    if (operatorid === "null" || operatorid === undefined) {
      setShowErroroperation(true);
    } else {
      const check = AuthServiceV2.NewToken();
      if (check != null) {
        check
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            setTextBody(err);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
      }
      getOperation();
    }
  };
  useEffect(() => {
    checkoperator();
  }, [reload_data]);

  const [chosenTable, setChosenTable] = useState(1);
  const [itemsPerPage] = useState(4);
  const [searchTermA, setSearchTermA] = useState("");
  const handleSearchA = (event) => {
    setSearchTermA(event.target.value);
  };

  const filteredDataA = itemsA.filter((item) => {
    return (
      item.id.toString().toLowerCase().includes(searchTermA.toLowerCase()) ||
      item.start_time
        .toString()
        .toLowerCase()
        .includes(searchTermA.toLowerCase()) ||
      item.end_time.toString().toLowerCase().includes(searchTermA.toLowerCase())
    );
  });

  const [currentPageA, setCurrentPageA] = useState(0);
  const startIndexA = currentPageA * itemsPerPage;
  const endIndexA = startIndexA + itemsPerPage;
  const currentItemsA = filteredDataA.slice(startIndexA, endIndexA);
  const handlePageChange = (page) => {
    if (page >= 0) setCurrentPageA(page);
  };

  const [approvedItems, setApprovedItems] = useState([]);
  const [unApprovedItems, setUnApprovedItems] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      const sortApproved = [];
      const sortUnAprroved = [];
      const sortFunction = async () => {
        for (let sortCount = 0; sortCount < itemsA.length; sortCount++) {
          if (itemsA[sortCount].operation_status_name === "อนุมัติ") {
            sortApproved.push(itemsA[sortCount]);
          } else {
            sortUnAprroved.push(itemsA[sortCount]);
          }
        }
        await Promise.all([
          setApprovedItems(sortApproved),
          setUnApprovedItems(sortUnAprroved),
        ]);
      };
      sortFunction();
    }, 100);
  }, [chosenTable]);
  const [searchApproveTerm, setSearchApproveTerm] = useState("");
  const handleApproveSearch = (event) => {
    setSearchApproveTerm(event.target.value);
    setTimeout(() => {}, 500);
  };

  const [searchTermCoop, setSearchTermCoop] = useState("");
  const handleSearchCoop = (event) => {
    setSearchTermCoop(event.target.value);
  };
  const filteredDataCoop = itemsB.filter((item) => {
    console.log(item)
    return (
      item.operation_id
        .toString()
        .toLowerCase()
        .includes(searchTermCoop.toLowerCase()) ||
      item.operation_code
        .toLowerCase()
        .includes(searchTermCoop.toLowerCase()) ||
      item.operation_start_time
        .toLowerCase()
        .includes(searchTermCoop.toLowerCase()) ||
      item.operation_end_time
        .toLowerCase()
        .includes(searchTermCoop.toLowerCase()) ||
      item.operation_status_name
        .toLowerCase()
        .includes(searchTermCoop.toLowerCase())
    );
  });

  const [currentPageCoop, setCurrentPageCoop] = useState(0);
  const startIndexCoop = currentPageCoop * itemsPerPage;
  const endIndexCoop = startIndexCoop + itemsPerPage;
  const currentItemsCoop = filteredDataCoop.slice(startIndexCoop, endIndexCoop);
  const handlePageChangeCoop = (page) => {
    if (page >= 0) setCurrentPageCoop(page);
  };

  const [searchValueA, setSeachValueA] = useState([
    "id",
    "start_time",
    "end_time",
  ]);
  const [dataA, setDataA] = useState([]);
  const [startArrA, setStartArrA] = useState(0);
  const handledataChangeA = (newPortion, startarr) => {
    setDataA(newPortion);
    setStartArrA(startarr);
  };

  const [searchValueB, setSeachValueB] = useState([
    "operation_id",
    "operation_code",
    "operation_start_time",
    "operation_end_time",
    "operation_status_name",
  ]);
  const [dataB, setDataB] = useState([]);
  const [startArrB, setStartArrB] = useState(0);
  const handledataChangeB = (newPortion, startarr) => {
    setDataB(newPortion);
    setStartArrB(startarr);
  };

  function center_Polygon(area) {
    area.map((value) => {
      console.log(value);
    });
    let polygon = turf.polygon([area]);
    let centroid = turf.centroid(polygon);
    console.log(centroid);
    return centroid; //return Geojson Form {tpye,props,geometry:{type,coordinates}}
  }
  function CancelJoinOp(co_id, status) {
    console.log(co_id, status);
    try {
      AuthService_Operation.CancelJoinOperation(co_id, status)
        .then((res) => {
          setModalToggle({ ...modalToggle, modalSuccess: true });
          setReload_Data(!reload_data);
          setTimeout(() => {
            handleClose();
            modal_handleClose();
          }, 1000);
        })
        .catch((err) => {
          alert("เกิดข้อผิดพลาด");
          setReload_Data(!reload_data);
        });
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    }
  }
  const [member_joining, setMember_Joining] = useState([]);
  function Get_Operation_Drone(operation_id) {
    console.log(operation_id);
    try {
      AuthServiceV2.Opearationdata(operation_id)
        .then((res) => {
          console.log(res);
          if (res !== undefined) {
            if (res.status === 200) {
              console.log(res.data.agency_data[0].drone_pilot_data);
              setMember_Joining(res.data.agency_data[0].drone_pilot_data);
              setTimeout(() => {
                modal_handleClose();
                setShowAprroveDroneList(true);
              }, 1000);
              console.log(member_joining);
            } else {
              alert(res.data.error_description);
            }
          } else {
            alert("ไม่พบข้อมูล");
          }
        })
        .catch((err) => {
          alert("เกิดข้อผิดพลาด");
        });
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    }
  }
  const [globalFilter, setGlobalFilter] = useState("");
  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <div> </div>
        {/* <h4 className="m-0">สถานะการลงทะเบียนโดรน</h4> */}
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();

  console.log(itemsA);
  function filter_item_on_going(data) {
    // console.log("data:", data);
    const filteredData = data.filter(
      (item) =>
        (item.operation_status_name === "ยื่นคำขอ" ||
          item.operation_status_name === "อนุมัติ" ||
          item.operation_status_name === "หน่วยงานยกเลิกภารกิจ") &&
        (item.id
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.start_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.operation_status_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.end_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.drone_model
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.pilot_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")))
    );

    return filteredData;
  }
  function filter_item_etc(data) {
    // console.log("data:", data);
    const filteredData = data.filter(
      (item) =>
        (item.operation_status_name === "ไม่อนุมัติ" ||
        item.operation_status_name === "เสร็จภารกิจ"||
        item.operation_status_name === "ภารกิจถูกยกเลิก") &&
        (item.id
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.start_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.operation_status_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.end_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.drone_model
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.pilot_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")))
    );

    return filteredData;
  }
  function filtered_itemB(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.id
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.start_time
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.operation_status_name
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.end_time
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))
    );

    return filteredData;
  }
  const Body_number = (data) => {
    return (
      <>
        <Button
          onClick={(e) => handleClick(e)}
          value={data.id}
          style={{
            background: "none",
            border: "none",
            color: "#575757",
            fontSize: "20px",
          }}
        >
          {data.id}
        </Button>
        <Overlay
          show={showTooltip}
          target={target}
          placement="top"
          //container={document.body}
          //containerPadding={20}
        >
          <Tooltip id="tooltip">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>คัดลอกรหัสปฏิบัติการเรียบร้อย</p>
            </div>
            {/* <div>{valuetool}</div>
          <div
            style={{ marginTop: "5px" }}
            onMouseEnter={ClipBHover}
            onClick={() => ClipBClick(valuetool)}
          >
            {clipboard_icon}
          </div> */}
          </Tooltip>
        </Overlay>
      </>
    );
  };
  const Body_Pilot_And_Drone = (item) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <FaUserAstronaut style={{ marginBottom: "5px" }} /> {item.pilot_name}
          <br />
          <GiDeliveryDrone style={{ marginBottom: "5px" }} /> {item.drone_model}
        </div>
      </div>
    );
  };
  const Body_Date = (data) => {
    const formattedStartDate = formatDate(data.start_time);
    const formattedEndDate = formatDate(data.end_time);
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            {/* <MdDateRange /> */}
            <p style={{ margin: "0" }}>
              {`${formattedStartDate.substring(
                0,
                10
              )} ${formattedStartDate.substring(11, 16)}`}
            </p>
            <p style={{ margin: "0" }}>|</p>
            <p style={{ margin: "0" }}>
              {`${formattedEndDate.substring(
                0,
                10
              )} ${formattedEndDate.substring(11, 16)}`}
            </p>
          </div>
        </div>
        {/* <div>{data.operation_type}</div> */}
      </>
    );
  };
  const Body_Operation_Type = (data) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>{data.operation_type.split("-")[0]}</p>
        </div>
      </>
    );
  };
  const Body_Status = (data) => {
    return (
      <Plan_Status status={data.operation_status_name ?? "ติดต่อเจ้าหน้าที่"} />
    );
  };
  const Body_Information = (data) => {
    return (
      <div>
        <p
          style={{ cursor: "pointer", fontSize: "25px", margin: "0px" }}
          className="investigate-button"
          onClick={() => {
            setShowUserOperationModal(true);

            setSelectedInformation([
              data.id,
              data.operation_type,
              data.start_time,
              data.end_time,
              data.operation_area.Volume3D.outline_polygon.vertices,
              data.operation_area.Volume3D.altitude,
              data.pilot_name,
              data.drone_model,
              data.purpose,
            ]);
          }}
        >
          <img
            alt="checkdata"
            src={docgif}
            style={{ width: "40px", height: "40px" }}
          />
        </p>
        {/* <FaRegEdit
          style={{ cursor: "pointer", fontSize: "25px" }}
          className="investigate-button"
          onClick={() => {
            setShowUserOperationModal(true);

            setSelectedInformation([
              data.id,
              data.operation_type,
              data.start_time,
              data.end_time,
              data.operation_area.Volume3D.outline_polygon
                .vertices,
              data.operation_area.Volume3D.altitude,
              data.pilot_name,
              data.drone_model,
              data.purpose,
            ]);
          }}
        /> */}
      </div>
    );
  };
  const Body_cancle = (data) => {
    return (
      <>
        {data.operation_status_name === "หน่วยงานยกเลิกภารกิจ" ? (
          <Button
            className="btn-twinkle"
            onClick={() => {
              AcceptRecindedOperation(data.operation_id);
              handleClose();
            }}
          >
            ยืนยันการถูกยกเลิกภารกิจ
          </Button>
        ) : (
          ""
        )}
      </>
    );
  };
  const Body_pilot_join = (data) => {
    return (
      <>
        <TbDrone
          style={{ cursor: "pointer", fontSize: "25px" }}
          className="investigate-button"
          onClick={() => {
            setModalToggle({
              ...modalToggle,
              modalwait: true,
            });
            Get_Operation_Drone(data.operation_id);
          }}
        />
        {data.operation_count >= 0 ? (
          <sup style={{ color: "green", fontWeight: "500" }}>
            {data.operation_count}
          </sup>
        ) : null}
      </>
    );
  };
  return (
    <div>
      {loading === true ? (
        <>
          <div className="loading-container" style={{ height: "20vh" }}>
            {" "}
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
          <Modal
            show={showErroroperation}
            onHide={() => setShowErroroperation(false)}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header>
              <Modal.Title>แจ้งเตือน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ท่านยังไม่ได้ขึ้นทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
            </Modal.Body>
            <Modal.Footer>
            <Button
                onClick={() => {
                  Navigate("/home");
                }}
              >
                หน้าหลัก
              </Button>
              <Button
                onClick={() => {
                  Navigate("/user/drone/regisDrone");
                }}
              >
                หน้าขึ้นทะเบียนโดรน
              </Button>
              <Button
                onClick={() => {
                  Navigate("/user/drone/statusDrone");
                }}
              >
                หน้าสถานะการขึ้นทะเบียน
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      ) : (
        <>
          {showInfomationA === true && (
            <Modal
              show={showInfomationA}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              size="xl"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  {/* ลำดับที่ {selectedInformation[0]}  */}
                  รหัสการปฏิบัติการ {selectedInformation[1]}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ margin: "0", padding: "0" }}>
                <div>
                  <MapContainer
                    center={
                      center_Polygon(selectedInformation[2]).geometry
                        .coordinates
                    }
                    zoom={13}
                    keyboard={true}
                    style={{ width: "100%", height: "50vh", zIndex: 1 }}
                  >
                    <TileLayer
                      style={{ zIndex: 2 }}
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Polygon
                      pathOptions={{ color: "blue" }}
                      positions={selectedInformation[2]}
                    />
                  </MapContainer>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ width: "100%", height: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <h4>
                        เวลาเริ่มต้น : {formatDate(selectedInformation[3])}
                      </h4>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <h4>
                        เวลาสิ้นสุด : {formatDate(selectedInformation[4])}
                      </h4>
                    </div>
                  </div>

                  {selectedInformation[5] === "ยื่นคำขอ" ? (
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        className="custom-btn btnCancel"
                        onClick={() => {
                          CancelOperation(selectedInformation[0]);
                          // window.location.reload(false);
                        }}
                      >
                        ยกเลิกคำขอ
                      </Button>
                    </div>
                  ) : selectedInformation[5] === "อนุมัติ" ? (
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      {cancancle ? (
                        <>
                          <div
                            style={{
                              width: "50%",
                              height: "100%",
                              textAlign: "center",
                            }}
                          >
                            <Button
                              className="custom-btn btnCancel"
                              onClick={() => {
                                DeAuthorizedOperation(selectedInformation[0]);
                                handleClose();
                              }}
                            >
                              ยกเลิกแผนการบิน
                            </Button>
                          </div>
                          <div
                            style={{
                              width: "50%",
                              height: "100%",
                              textAlign: "center",
                            }}
                          >
                            <Button
                              className="custom-btn btnEdit2"
                              onClick={() => {
                                Navigate("/user/drone/updatepolygon", {
                                  state: {
                                    passedOperationID: selectedInformation[0],
                                    passedArea: selectedInformation[2],
                                    passedTimeStart: selectedInformation[3],
                                    passedTimeEnd: selectedInformation[4],
                                  },
                                });
                                handleClose();
                              }}
                            >
                              แก้ไขแผนการบิน
                            </Button>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            width: "50%",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <Button
                            variant="success"
                            onClick={() => {
                              CompleteOperation(selectedInformation[0]);
                              handleClose();
                            }}
                          >
                            <h4 style={{ color: "white" }}>เสร็จภารกิจ</h4>
                          </Button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Button className="custom-btn btnDisable" disabled>
                        ยกเลิกคำขอ
                      </Button>
                    </div>
                  )}
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {showInfomationB === true && (
            <Modal
              show={showInfomationB}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              size="xl"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  {/* ลำดับที่ {selectedInformation[0]}  */}
                  รหัสการปฏิบัติการ {selectedInformation[1]}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ margin: "0", padding: "0" }}>
                <div>
                  <MapContainer
                    center={
                      center_Polygon(selectedInformation[2]).geometry
                        .coordinates
                    }
                    zoom={15}
                    keyboard={true}
                    style={{ width: "100%", height: "50vh", zIndex: 1 }}
                  >
                    <TileLayer
                      style={{ zIndex: 2 }}
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Polygon
                      pathOptions={{ color: "blue" }}
                      positions={selectedInformation[2]}
                    />
                  </MapContainer>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div
                  style={{ width: "100%", height: "100%", fontSize: "22px" }}
                >
                  <div className="modal-body-grid2">
                    <div className="grid-item">
                      เวลาเริ่มต้น : {selectedInformation[3]}
                    </div>
                    <div className="grid-item">
                      เวลาสิ้นสุด : {selectedInformation[4]}
                    </div>
                  </div>
                  <div className="modal-body-grid2">
                    <div className="grid-item">
                      จำนวนโดรน : {selectedInformation[6]}
                    </div>
                    <div className="grid-item">
                      ความสูง : {selectedInformation[7]}
                    </div>
                  </div>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {showApproveDroneList === true && (
            <Modal
              show={showApproveDroneList}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              size="xl"
              centered
            >
              <Modal.Body style={{ margin: "0", padding: "0" }}>
                <div
                  className="container-main"
                  style={{ width: "90%", marginLeft: "5%" }}
                >
                  <div style={{ textAlign: "end" }}>
                    <p>จำนวน {member_joining.length} รายการ</p>
                  </div>
                  <Table
                    striped
                    responsive
                    overflow
                    bordered={false}
                    hover
                    className="table-main"
                    style={{
                      marginTop: "0px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th className="table-space" style={{ width: "5%" }}>
                          ลำดับ
                        </th>
                        <th className="table-space" style={{ width: "25%" }}>
                          ชื่อนักบิน
                        </th>
                        <th className="table-space">โมเดลของโดรน</th>
                        <th className="table-space" style={{ width: "15%" }}>
                          สถานะ
                        </th>
                        <th className="table-space" style={{ width: "15%" }}>
                          ยกเลิกนักบิน
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {member_joining !== undefined
                        ? member_joining.map((item, index) => (
                            <>
                              <tr key={index}>
                                <td className="table-space">{index + 1}</td>
                                <td className="table-space">
                                  {item.pilot_name}
                                </td>
                                <td className="table-space">
                                  {item.drone_brand_model}
                                </td>
                                <td
                                  className="table-space"
                                  style={{
                                    color: (() => {
                                      switch (item.status_name) {
                                        case "อนุมัติ":
                                        case "อนุญาตให้ขึ้นบิน":
                                        case "เสร็จภารกิจ":
                                          return "#008000";
                                        case "ภารกิจถูกยกเลิก":
                                        case "ยกเลิกภารกิจ":
                                        case "ไม่อนุมัติ":
                                        case "หน่วยงานยกเลิกภารกิจ":
                                          return "#FF0000";
                                        default:
                                          return "#FF8C00";
                                      }
                                    })(),
                                  }}
                                >
                                  {item.status_name ?? "ติดต่อเจ้าหน้าที่"}
                                </td>
                                <td
                                  className="table-space"
                                  onClick={() => {
                                    console.log("Approved");
                                    CancelJoinOp(item.operation_co_id, 3);
                                  }}
                                >
                                  <button
                                    className="custom-btn btnCancel"
                                    style={{
                                      fontSize: "16px",
                                      width: "120px",
                                      height: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    ยกเลิก
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))
                        : null}
                    </tbody>
                  </Table>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ width: "100%", height: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  ></div>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {showUserOperationModal && (
            <UserOperationContentModal
              toggleModal={showUserOperationModal}
              onHide={handleToggleUserOperationModal}
              content={{
                id: selectedInformation[0],
                type: selectedInformation[1],
                start: selectedInformation[2],
                end: selectedInformation[3],
                positions: selectedInformation[4],
                height: selectedInformation[5],
                pilot_name: selectedInformation[6],
                drone_model: selectedInformation[7],
                purpose: selectedInformation[8],
              }}
            />
          )}

          <Modal
            show={showErroroperation}
            onHide={() => setShowErroroperation(false)}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header>
              <Modal.Title>แจ้งเตือน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ท่านยังไม่ได้ขึ้นทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
            </Modal.Body>
            <Modal.Footer>
            <Button
                onClick={() => {
                  Navigate("/home");
                }}
              >
                หน้าหลัก
              </Button>
              <Button
                onClick={() => {
                  Navigate("/user/drone/regisDrone");
                }}
              >
                หน้าขึ้นทะเบียนโดรน
              </Button>
              <Button
                onClick={() => {
                  Navigate("/user/drone/statusDrone");
                }}
              >
                หน้าสถานะการขึ้นทะเบียน
              </Button>
            </Modal.Footer>
          </Modal>
          {showUserOperationModal && (
            <UserOperationContentModal
              toggleModal={showUserOperationModal}
              onHide={handleToggleUserOperationModal}
              content={{
                id: selectedInformation[0],
                type: selectedInformation[1],
                start: selectedInformation[2],
                end: selectedInformation[3],
                positions: selectedInformation[4],
                height: selectedInformation[5],
                pilot_name: selectedInformation[6],
                drone_model: selectedInformation[7],
                purpose: selectedInformation[8],
              }}
            />
          )}

          <div className="menu-selection">
            <h1>{t('operationlist.main')}</h1>
            {/* {Object.keys(itemsA).length !== 0 && (
              <div className="form-toggle">
                <input
                  type="checkbox"
                  id="toggle"
                  className="toggleCheckbox"
                  onChange={() => {
                    if (chosenTable === 1) {
                      setChosenTable(2);
                    } else if (chosenTable === 2) {
                      setChosenTable(1);
                    }
                    setSearchTermA("");
                    setSearchTermCoop("");
                  }}
                />

                <label htmlFor="toggle" className="toggleContainer">
                  <div>ปฏิบัติการของฉัน</div>

                  <div>เข้าร่วมปฏิบัติการ</div>
                </label>
              </div>
            )} */}
          </div>
          <div style={{ display: "flex" }}>
            {/* Tab 1 */}
            <div
              style={{
                backgroundColor: chosenTable === 1 ? "#ffffff" : "#E6E8EA",
                color: chosenTable === 1 ? "#000" : "#7D7D7D",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                boxShadow:
                  chosenTable === 1
                    ? "0px -10px 15px rgba(0, 0, 0, 0.3)"
                    : "0px -1px 10px rgba(0, 0, 0, 0.2)",
                width: "10%",
                height: "60px",
                borderRadius: "10px 10px 0px 0px",
                cursor: "pointer",
                marginLeft: "10%",
                marginRight: "10px", // เพิ่มระยะห่างระหว่างแท็บ
              }}
              onClick={() => setChosenTable(1)}
            >
              {t('operationlist.submain1')}
            </div>

            {/* Tab 2 */}
            <div
              style={{
                backgroundColor: chosenTable === 2 ? "#ffffff" : "#E6E8EA",
                color: chosenTable === 2 ? "#000" : "#7D7D7D",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                boxShadow:
                  chosenTable === 2
                    ? "0px -10px 15px rgba(0, 0, 0, 0.3)"
                    : "0px 0px 10px rgba(0, 0, 0, 0.2)",
                width: "10%",
                height: "60px",
                borderRadius: "10px 10px 0px 0px",
                cursor: "pointer",
              }}
              onClick={() => setChosenTable(2)}
            >
              {t('operationlist.submain2')}
            </div>
          </div>
          <div
            className="container-main"
            style={{
              marginTop: "0px",
              borderRadius: "0px 10px 10px 10px",
              boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.2)",
              borderTop: "solid 1px groove",
            }}
          >
            {chosenTable === 1 ? (
              <>
                <div className="table-card-header" style={{ marginTop: "0px" }}>
                  <h4 className="header-main" style={{ color: "white" }}>
                    {t('operationlist.headtitle')}
                  </h4>
                </div>
                <div style={{ textAlign: "end", marginTop: "35px" }}>
                  <p>จำนวน {itemsA.length}</p>
                </div>

                <DataTable
                  value={filter_item_on_going(itemsA)}
                  paginator
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  rows={5}
                  rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                  header={header}
                  emptyMessage="ไม่มีข้อมูล"
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ fontFamily: "Kanit" }}
                >
                  <Column
                    header={t('operationlist.OperationCode')}
                    body={Body_number}
                    field={`id`}
                    sortable
                    filterField="id"
                    dataType="date"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.pilotandUAV')}
                    body={Body_Pilot_And_Drone}
                    field={`pilot_name`}
                    sortable
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.time')}
                    body={Body_Date}
                    field={"start_time"}
                    sortable
                    filterField="start_time"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.type')}
                    body={Body_Operation_Type}
                    field="operation_type"
                    sortable
                    filterField="operation_type"
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.status')}
                    body={Body_Status}
                    field={`operation_status_name`}
                    sortable
                    filterField="operation_status_name"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.checkdata')}
                    body={Body_Information}
                    field={`built_in_rid`}
                    sortable
                    filterField="built_in_rid"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header={t('operationlist.otc')}
                    field={"connect_rid"}
                    body={Body_cancle}
                    //sortable
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "5%" }}
                  ></Column>
                </DataTable>

                <div
                  className="table-card-header"
                  style={{ marginTop: "50px" }}
                >
                  <h4 className="header-main" style={{ color: "white" }}>
                    {t('operationlist.successtitle')}
                  </h4>
                </div>
                <div style={{ textAlign: "end", marginTop: "35px" }}>
                  {/* <p>จำนวน {itemsA.length}</p> */}
                </div>

                <DataTable
                  value={filter_item_etc(itemsA)}
                  paginator
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  rows={5}
                  rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                  header={header}
                  emptyMessage="ไม่พบข้อมูล"
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ fontFamily: "Kanit" }}
                >
                  <Column
                    header={t('operationlist.OperationCode')}
                    body={Body_number}
                    field={`id`}
                    sortable
                    filterField="id"
                    dataType="date"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.pilotandUAV')}
                    body={Body_Pilot_And_Drone}
                    field={`pilot_name`}
                    sortable
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.time')}
                    body={Body_Date}
                    field={"start_time"}
                    sortable
                    filterField="start_time"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.type')}
                    body={Body_Operation_Type}
                    field="operation_type"
                    sortable
                    filterField="operation_type"
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.status')}
                    body={Body_Status}
                    field={`operation_status_name`}
                    sortable
                    filterField="operation_status_name"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.checkdata')}
                    body={Body_Information}
                    field={`built_in_rid`}
                    sortable
                    filterField="built_in_rid"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>

                  {/* <Column
                    header="อื่นๆ"
                    field={"connect_rid"}
                    body={Body_cancle}
                    //sortable
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "5%" }}
                  ></Column> */}
                </DataTable>
              </>
            ) : (
              <>
                <div className="table-card-header" style={{ marginTop: "0px" }}>
                  <h4 className="header-main" style={{ color: "white" }}>
                  {t('operationlist.submain2')}
                  </h4>
                </div>
                <div style={{ textAlign: "end", marginTop: "35px" }}>
                  <p>จำนวน {itemsB.length}</p>
                </div>

                {/* <Table
                  striped
                  bordered={false}
                  hover
                  className="table-main"
                  style={{ marginTop: "0px" }}
                >
                  <thead>
                    <tr>
                      
                      <th className="table-space" style={{ width: "20%" }}>
                        รหัสการปฏิบัติการ
                      </th>
                      <th className="table-space" style={{ width: "15%" }}>
                        เวลาปฏิบัติการบิน
                      </th>
                      <th className="table-space" style={{ width: "15%" }}>
                        เวลาสิ้นสุดภารกิจ
                      </th>
                      <th className="table-space" style={{ width: "15%" }}>
                        สถานะ
                      </th>
                      <th className="table-space">ผู้เข้าร่วม ปฏิบัติการ</th>
                      <th className="table-space" style={{ width: "15%" }}>
                        ตรวจสอบข้อมูล
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsB.length === 0 ? (
                      <>
                        <th colSpan={6}>
                          <h4 className="header-main">ไม่พบข้อมูล</h4>
                        </th>
                      </>
                    ) : (
                      <>
                        {itemsB.map((item, index) => (
                          <tr key={index + 1}>
                           
                            <td className="table-space">
                              <Button
                                onClick={(e) => handleClick(e)}
                                value={item.id}
                                style={{
                                  background: "none",
                                  border: "none",
                                  color: "#575757",
                                  fontSize: "20px",
                                }}
                              >
                                {item.id.substring(0, 13) + " ..."}
                              </Button>
                              <Overlay
                                show={showTooltip}
                                target={target}
                                placement="top"
                              >
                                <Tooltip id="tooltip">
                                  <div>{valuetool}</div>

                                  <div
                                    style={{ marginTop: "5px" }}
                                    onMouseEnter={ClipBHover}
                                    onClick={() => ClipBClick(valuetool)}
                                  >
                                    {clipboard_icon}
                                  </div>
                                </Tooltip>
                              </Overlay>
                            </td>
                            <td className="table-space">
                              {formatDate(item.start_time)}
                            </td>
                            <td className="table-space">
                              {formatDate(item.end_time)}
                            </td>
                            {item.status1_count === 1 && (
                              <td
                                style={{ color: "orange" }}
                                className="table-space"
                              >
                                ขออนุญาตหน่วยงาน
                              </td>
                            )}
                            {item.status3_count === 1 && (
                              <td
                                style={{ color: "green" }}
                                className="table-space"
                              >
                                หน่วยงานอนุมัติ
                              </td>
                            )}
                            {item.status4_count === 1 && (
                              <td
                                style={{ color: "green" }}
                                className="table-space"
                              >
                                การบินพลเรือนอนุมัติ
                              </td>
                            )}
                            <td
                              className="table-space"
                              
                            >
                              {
                                <Plan_Status
                                  status={
                                    item.operation_status_name ??
                                    "ติดต่อเจ้าหน้าที่"
                                  }
                                />
                              }
                            </td>
                            <td className="table-space">
                              <TbDrone
                                style={{ cursor: "pointer", fontSize: "25px" }}
                                className="investigate-button"
                                onClick={() => {
                                  setModalToggle({
                                    ...modalToggle,
                                    modalwait: true,
                                  });
                                  Get_Operation_Drone(item.operation_id);
                                }}
                              />
                              {item.operation_area.aircraft_count >= 0 ? (
                                <sup
                                  style={{ color: "green", fontWeight: "500" }}
                                >
                                  {item.operation_area.aircraft_count}
                                </sup>
                              ) : null}
                            </td>
                            <td className="table-space">
                              <FaRegEdit
                                style={{ cursor: "pointer", fontSize: "25px" }}
                                className="investigate-button"
                                onClick={() => {
                                  setShowUserOperationModal(true);
                                  setSelectedInformation([
                                    item.id,
                                    item.operation_type,
                                    item.start_time,
                                    item.end_time,
                                    item.operation_area.Volume3D.outline_polygon
                                      .vertices,
                                    item.operation_area.Volume3D.altitude,
                                    item.pilot_name,
                                    item.drone_model,
                                    item.purpose,
                                  ]);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </Table> */}
                {/* <PaginationS
                  data={itemsB}
                  onPortionChange={handledataChangeB}
                  searchValue={searchValueB}
                /> */}
                <DataTable
                  value={globalFilter ? filtered_itemB(itemsB) : filter_item_on_going(itemsB)}
                  paginator
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  rows={5}
                  rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                  header={header}
                  emptyMessage="ไม่มีข้อมูล"
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ fontFamily: "Kanit" }}
                >
                  <Column
                    header={t('operationlist.OperationCode')}
                    body={Body_number}
                    field={`id`}
                    sortable
                    filterField="id"
                    dataType="date"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "12%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.time')}
                    body={Body_Date}
                    field={"start_time"}
                    sortable
                    filterField="start_time"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.type')}
                    body={Body_Operation_Type}
                    field="operation_type"
                    sortable
                    filterField="operation_type"
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.status')}
                    body={Body_Status}
                    field={`operation_status_name`}
                    sortable
                    filterField="operation_status_name"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.pilotjoin')}
                    field={"operation_area.aircraft_count"}
                    body={Body_pilot_join}
                    sortable
                    filterField="operation_area.aircraft_count"
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "12%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.checkdata')}
                    body={Body_Information}
                    field={`built_in_rid`}
                    //sortable
                    filterField="built_in_rid"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "20%" }}
                  ></Column>
                </DataTable>
                <div
                  className="table-card-header"
                  style={{ marginTop: "50px" }}
                >
                  <h4 className="header-main" style={{ color: "white" }}>
                    {t('operationlist.successtitle')}
                  </h4>
                </div>
                <div style={{ textAlign: "end", marginTop: "35px" }}>
                  {/* <p>จำนวน {itemsA.length}</p> */}
                </div>
                <DataTable
                  value={globalFilter ? filtered_itemB(itemsB) : filter_item_etc(itemsB)}
                  paginator
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  rows={5}
                  rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                  header={header}
                  emptyMessage="ไม่มีข้อมูล"
                  tableStyle={{ minWidth: "50rem" }}
                  style={{ fontFamily: "Kanit" }}
                >
                  <Column
                    header={t('operationlist.OperationCode')}
                    body={Body_number}
                    field={`id`}
                    sortable
                    filterField="id"
                    dataType="date"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "12%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.time')}
                    body={Body_Date}
                    field={"start_time"}
                    sortable
                    filterField="start_time"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.type')}
                    body={Body_Operation_Type}
                    field="operation_type"
                    sortable
                    filterField="operation_type"
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.status')}
                    body={Body_Status}
                    field={`operation_status_name`}
                    sortable
                    filterField="operation_status_name"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "15%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.pilotjoin')}
                    field={"operation_area.aircraft_count"}
                    body={Body_pilot_join}
                    sortable
                    filterField="operation_area.aircraft_count"
                    //sortFunction={customSort}
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "12%" }}
                  ></Column>
                  <Column
                    header={t('operationlist.checkdata')}
                    body={Body_Information}
                    field={`built_in_rid`}
                    //sortable
                    filterField="built_in_rid"
                    bodyStyle={{ textAlign: "center" }}
                    style={{ width: "20%" }}
                  ></Column>
                </DataTable>
              </>
            )}
          </div>
        </>
      )}
      {/* Modal Waiting */}
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <Modal
        size="sm"
        show={modalToggle.modalwait}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Header>
          <Modal.Body>
            <div class="container-modal-loding">
              <div class="flex">
                <div class="loader" />
              </div>
              <div class="load-text">กรุณารอสักครู่...</div>
            </div>
          </Modal.Body>
        </Modal.Header>
      </Modal>
      {/* action success */}
      <Modal
        size="sm"
        show={modalToggle.modalSuccess}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Body style={{ height: "250px" }}>
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip" />
              <span class="icon-line line-long" />
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </div>

          <h3 class="text-center text-success">สำเร็จ!</h3>
        </Modal.Body>
      </Modal>
      {/* action denied */}
      <Modal
        size="sm"
        show={modalToggle.modalDenied}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Body style={{ height: "250px" }}>
          <div class="wrap">
            <svg
              width="100"
              height="100"
              viewBox="0 0 447 447"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel-mark">
                <rect width="447" height="447" fill="white" />
                <circle
                  id="Circle"
                  cx="223.5"
                  cy="223.5"
                  r="210.5"
                  stroke="#9F2B2B"
                  stroke-width="26"
                />
                <g id="X-mark">
                  <line
                    id="Line"
                    x1="119.385"
                    y1="115.92"
                    x2="330.92"
                    y2="325.615"
                    stroke="#9F2B2B"
                    stroke-width="26"
                    stroke-linecap="round"
                  />
                  <line
                    id="Line"
                    x1="331.809"
                    y1="119.384"
                    x2="119.384"
                    y2="328.178"
                    stroke="#9F2B2B"
                    stroke-width="26"
                    stroke-linecap="round"
                  />
                </g>
              </g>
            </svg>
          </div>
          <h3 class="text-center text-danger">ยกเลิก!</h3>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OperationTable;
